module.exports = __webpack_public_path__ + "static/media/stop.547e60b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/stop.svg
// module id = 773
// module chunks = 0